( function (a) {
    const $lookupContainer = a('body').find('#lookup-container');

    const $postalCodeField = $lookupContainer.find('[name=postal_code]');
    const $streetNumber = $lookupContainer.find('[name=street_number]');
    const $streetNumberSuffix = $lookupContainer.find('[name=street_number_suffix]');

    const $performLookupButton = $lookupContainer.find('[type=submit]');

    const $jsonResponse = $lookupContainer.find('#json-response');
    const $jsonResponseContent = $jsonResponse.find('.content');

    if (!!$lookupContainer.length) {

        const displayResponse = (response) => {
            let parsedResponse = JSON.stringify(response, null, 2);

            parsedResponse = parsedResponse
                .replace(/"(.*)":/g, '<span data-highlight-value>"$1"</span>:')
                .replace(/"(.*)"/g, '<span data-highlight-key>"$1"</span>')
                .replace(/([-]?\d+\.\d+)/g, '<span data-highlight-value>$1</span>')
                .replace(/[:]/g, '<span data-highlight-default>:</span>');

            $jsonResponseContent.html(parsedResponse);
            $jsonResponse.addClass('is-visible');
        };

        const hideResponse = () => {
            if ($jsonResponse.hasClass('is-visible')) {
                $jsonResponse.removeClass('is-visible');
                $jsonResponseContent.empty();
            }
        };

        const performLookup = (event) => {
            event.preventDefault();

            if ($postalCodeField.val().length > 0 && $streetNumber.val().length > 0) {
                $performLookupButton.addClass('is-loading');

                const postalCodeValue = $postalCodeField.val().replace(/\s/g, '').toUpperCase();
                const streetNumber = parseInt($streetNumber.val(), 10);

                const streetNumberSuffix = $streetNumberSuffix.val().replace(/\s/g, '');

                a.ajax(window.location.origin + '/widget/lookup?postal_code=' + postalCodeValue + '&street_number=' + streetNumber + '&street_number_suffix=' + streetNumberSuffix, {
                    method: 'GET',
                    cache: false,
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    complete: (response) => {
                        $performLookupButton.removeClass('is-loading');
                        displayResponse(response.responseJSON);
                    }
                });
            }
        };

        // Perform the lookup on change
        $performLookupButton.on('click', performLookup);

        a(document).on('keydown', (event) => {
            if (event.which === 13) {
                performLookup(event);
            }
        });

        $postalCodeField.on('keyup', hideResponse);
        $streetNumber.on('keyup', hideResponse);
        $streetNumberSuffix.on('keyup', hideResponse);
    }

}(jQuery));
